var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentslarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.41 20.1.52.24c1.73.78 2.9 1.09 5.02 1.09 5.7 0 10.16-4.35 10.16-9.55 0-5.19-4.46-9.54-10.16-9.54-5.73 0-10.16 3.99-10.16 9.54 0 2.07.74 3.38 1.48 4.7l.05.08.34.6-1.25 3.92 4-1.07Zm-.13 1.7c1.91.86 3.3 1.23 5.67 1.23 6.5 0 11.76-5 11.76-11.15S18.45.74 11.95.74.2 5.33.2 11.88c0 2.5.92 4.12 1.67 5.45l.07.12-1.48 4.63a.8.8 0 0 0 .96 1.02l4.87-1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentslarge);
export default __webpack_public_path__ + "static/media/comments.large.25b165db22367badd0d06502222576e2.svg";
export { ForwardRef as ReactComponent };